import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, Validators } from '@angular/forms';

@Directive({
  selector: '[appValidName]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ValidNameDirective, multi: true }]
})
export class ValidNameDirective implements Validator {
  reggy :RegExp = new RegExp(/^[a-zA-Z\-\ ]*$/);
  constructor() { }
  validate(control: AbstractControl): {[key: string]: any} {
    let rslt = Validators.pattern(this.reggy)(control);
    return !rslt ? null : { 'validName' : true };
  }
}
